
import React from 'react';
import { sprintf } from "sprintf-js";
import {DashboardTable} from "../dashboard-table";
import { QueuePartition, QueueType } from "../../../lib/proto/queue_proto";
import {dollarToString} from "../../../lib/currency-utils";

const REBALANCE_REASON = {
  REBALANCE_INITIAL: "Initial allocation",
  REBALANCE_LOW: "Underperformance",
  REBALANCE_HIGH: "Overperformance",
  REBALANCE_CASH: "MTW",
  REBALANCE_MANUAL: "Manual",
  REBALANCE_WITHDRAWAL: "Withdrawal",
  REBALANCE_DEPOSIT: "Deposit",
}

const render_item = (component, queue_item, index, value, prop, on_click, selected) => {

  const on_enter = (enter) => ev => {
    if (enter) {
      component.setState({
        [prop]: index,
      });
    } else {
      component.setState({
        [prop]: -1,
      });
    }
  }
  const click_local = () => {
    on_click(queue_item);
  }
  const style = {
    fontWeight: (component.state[prop] === index || selected) ? "bold" : "normal",
  }
  return(
    <div
      onClick={click_local}
      onMouseEnter={on_enter(true)}
      onMouseLeave={on_enter(false)}>
      <div style={style}>
        { value }
      </div>
    </div>

  );
}

const calc_pct_managed = (item, etf_to_category, securities_usd) => {
  let total_cents = 0;
  if (securities_usd === 0) {
    return 0;
  }
  const alloc = item.metadata.new_alloc;
  Object.keys(alloc).forEach(sym => {
    if (sym !== "CASH" && sym in etf_to_category) {
      total_cents += alloc[sym].price_cents * alloc[sym].size;
    }
  });
  return total_cents / 100 / securities_usd * 100;
}

const calc_securities_usd = item => {
  let total_cents = 0;
  const alloc = item.metadata.new_alloc;
  Object.keys(alloc).forEach(sym => {
    if (sym !== "CASH") {
      total_cents += alloc[sym].price_cents * alloc[sym].size;
    }
  });
  return total_cents / 100;
}

const RebalanceTable = props => {

  let items = Array.from(props.items);
  const component = props.component;
  const etf_to_category = component.props.notification.etf_to_category;

  if (!items) {
    return null;
  }

  if (props.selected) {
    const index = items.findIndex(item => item.id === props.selected);
    if (index >= 0) {
      items.splice(0, index - 2);
    }
  }

  const data = [
    [ "Id", "Portfolio", "Cash", "Securities", "Pct Managed", "Reason", "Date Started", "Date Executed", "Date Cancelled",
      "Current Risk", "New Risk" ],
  ];


  const closed_partition_a = sprintf("QUEUE_%s_%s",
    QueueType.Rebalance.id, QueuePartition.QUEUE_PARTITION_CLOSED.label);
  const closed_partition_b = sprintf("QUEUE_%s_%s",
    "Rebalance2", QueuePartition.QUEUE_PARTITION_CLOSED.label);
  const canceled_partition_a = sprintf("QUEUE_%s_%s",
    QueueType.Rebalance.id, QueuePartition.QUEUE_PARTITION_CANCELED.label);
  const canceled_partition_b = sprintf("QUEUE_%s_%s",
    "Rebalance2", QueuePartition.QUEUE_PARTITION_CANCELED.label);

  const on_click = item => {
    const path = "/super-admin/rebalance";
    const args = {
      id: item.id,
      no_portfolio: "true",
    }
    component.props.navigatePath(path, args);
  }

  items.forEach((item, index) => {

    let executed_date, canceled_date, started_date;
    started_date = item.opened_date;
    const selected = item.id === props.selected;
    if (item.partition === "NOTIFICATION_QUEUE_CLOSED") {
      executed_date = item.executed;
    } else if (item.partition === closed_partition_a || item.partition === closed_partition_b) {
      executed_date = item.closed_date;
    }
    if (item.partition === "NOTIFICATION_QUEUE_CANCELED") {
      canceled_date = item.executed;
    } else if (item.partition === canceled_partition_a || item.partition === canceled_partition_b) {
      canceled_date = item.closed_date;
    }
    const span_style = {
      fontWeight: selected ? "bold" : "normal",
    }
    const portfolio_usd = item.metadata.portfolio_usd;
    const cash_usd = item.metadata.cash_usd;
    const securities_usd = calc_securities_usd(item);
    const managed_pct = calc_pct_managed(item, etf_to_category, securities_usd);
    data.push([
      render_item(component, item, index, item.id, "queue_index", on_click, selected),
      (<span style={span_style}>{dollarToString(portfolio_usd)}</span>),
      (<span style={span_style}>{dollarToString(cash_usd)}</span>),
      (<span style={span_style}>{dollarToString(securities_usd)}</span>),
      (<span style={span_style}>{sprintf("%.2f %%", managed_pct)}</span>),
      (<span style={span_style}>{REBALANCE_REASON[item.reason || item.metadata.reason]}</span>),
      (<span style={span_style}>{started_date}</span>),
      (<span style={span_style}>{executed_date}</span>),
      (<span style={span_style}>{canceled_date}</span>),
      (<span style={span_style}>{sprintf("%.2f", item.current_risk || item.metadata.current_risk)}</span>),
      (<span style={span_style}>{sprintf("%.2f", item.new_risk || item.metadata.new_risk)}</span>),
    ])
  })

  const style_rules = [
    {
      pred: (row) => row % 2,
      style: {
        backgroundColor: "#EEE",
      }
    },
    {
      pred: (row) => row === 0,
      style: {
        borderBottom: "solid 1px black",
      }
    }
  ]
  const table_style = {
    width: "100%",
  }
  return (
    <div>
      <DashboardTable
        tableStyle={table_style}
        tdStyleLut={style_rules}
        data={data}/>
    </div>
  )

}

export { RebalanceTable };
